import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApiCluAgentService {
    baseEndpointUrl : string | null = localStorage.getItem('CAURIS_LINKUP_FOP_AGENT_URL') || null;
    endPoints = this.initEndpoints(this.baseEndpointUrl);

    constructor() {
    }

    setEndpointUrl(_endpointUrl: string) {
        localStorage.setItem('CAURIS_LINKUP_FOP_AGENT_URL', _endpointUrl);
        this.baseEndpointUrl = _endpointUrl;
        this.endPoints = this.initEndpoints(this.baseEndpointUrl);
    }

    private initEndpoints(baseEndpointUrl: string | null) {
        if (baseEndpointUrl == null) { return null; }
        return {
            // APP
            doGetAppVersionAction_App: baseEndpointUrl + '/api/App/doGetAppVersionAction_App',
            doGetStartupInfosAction_App: baseEndpointUrl + '/api/App/doGetStartupInfosAction_App',
            doGetParamsAction_App: baseEndpointUrl + '/api/App/doGetParamsAction_App',
            doSaveParamsAction_App: baseEndpointUrl + '/api/App/doSaveParamsAction_App',

            // AUTH 
            doAuthenticateAction_Auth: baseEndpointUrl + '/api/Auth/doAuthenticateAction_Auth',

            // STANDARD PRINTER
            doTestPrinterAction_StandardPrinter: baseEndpointUrl + '/api/StandardPrinter/doTestPrinterAction_StandardPrinter',
            doPrintDocumentAction_StandardPrinter: baseEndpointUrl + '/api/StandardPrinter/doPrintDocumentAction_StandardPrinter',
            doSaveStandardPrinterConfigAction_StandardPrinter: baseEndpointUrl + '/api/StandardPrinter/doSaveStandardPrinterConfigAction_StandardPrinter',

            // SERIAL PRINTER
            doTestPrinterAction_SerialPrinter: baseEndpointUrl + '/api/SerialPrinter/doTestPrinterAction_SerialPrinter',
            doPrintDocumentAction_SerialPrinter: baseEndpointUrl + '/api/SerialPrinter/doPrintDocumentAction_SerialPrinter',
            doOpenCashdeskAction_SerialPrinter: baseEndpointUrl + '/api/SerialPrinter/doOpenCashdeskAction_SerialPrinter',

            // SERIAL DISPLAY
            doTestDisplayAction_SerialDisplay: baseEndpointUrl + '/api/SerialDisplay/doTestDisplayAction_SerialDisplay',
            doShowTextAction_SerialDisplay: baseEndpointUrl + '/api/SerialDisplay/doShowTextAction_SerialDisplay',

            // SERIAL CASH BALANCE
            doGetCurrentWeightInfosAction_SerialCashBalance: baseEndpointUrl + '/api/SerialCashBalance/doGetCurrentWeightInfosAction_SerialCashBalance',

            // CASHDESK SYNC
            doGetListTicketsItemsAction_CashDeskSync: baseEndpointUrl + '/api/CashDeskSync/doGetListTicketsItemsAction_CashDeskSync',
            doRunTicketSyncUpAction_CashDeskSync: baseEndpointUrl + '/api/CashDeskSync/doRunTicketSyncUpAction_CashDeskSync',
        };
    }
}